import styled from 'styled-components';
import React, { useContext, useRef, useState, useCallback, useEffect } from 'react';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import { useOnClickOutside } from '../../hooks/useOnClickOutside/useOnClickOutside.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import { TableSemanticContext } from './TableSemanticContext.es.js';
import { TableContext } from './TableContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Body = styled(Box)`
    display: table-row-group;
`;
const TableBody = (_a) => {
  var _b = _a, { children, rowsCount } = _b, props = __objRest(_b, ["children", "rowsCount"]);
  const { setBodyNode, dispatchRowChangedEvent, onRowChange, listenKeyEvents, focusedIndexRef } = useContext(TableContext);
  const tableRef = useRef(null);
  const [childrenCount, setChildrenCount] = useState(rowsCount || 0);
  const handleRowChange = useCallback((newRowIndex, event) => {
    event == null ? void 0 : event.preventDefault();
    dispatchRowChangedEvent(newRowIndex, (event == null ? void 0 : event.type) === "keydown");
    onRowChange && onRowChange(newRowIndex, event);
  }, [onRowChange, dispatchRowChangedEvent]);
  const handleKeyDown = useCallback((event) => {
    let newRowIndex = -1;
    switch (event.key) {
      case "ArrowDown":
        newRowIndex = Math.min(focusedIndexRef.current + 1, childrenCount - 1);
        handleRowChange(newRowIndex, event);
        break;
      case "ArrowUp":
        newRowIndex = Math.max(focusedIndexRef.current - 1, 0);
        handleRowChange(newRowIndex, event);
        break;
    }
  }, [childrenCount, focusedIndexRef, handleRowChange]);
  const handleClickOutside = useCallback(() => {
    handleRowChange(-1);
  }, [handleRowChange]);
  useEffect(() => {
    if (children) {
      setChildrenCount(rowsCount || React.Children.count(children));
    }
  }, [children, rowsCount]);
  useEffect(() => {
    if (listenKeyEvents) {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [listenKeyEvents, handleKeyDown]);
  useOnClickOutside(tableRef, handleClickOutside);
  useEffect(() => {
    setBodyNode(tableRef.current);
  }, [setBodyNode]);
  return /* @__PURE__ */ React.createElement(TableSemanticContext.Provider, {
    value: { location: "body" }
  }, /* @__PURE__ */ React.createElement(Body, __spreadValues({
    ref: tableRef
  }, props), children));
};

export { TableBody };
//# sourceMappingURL=TableBody.es.js.map
